import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { listCurrencies, listTerms } from "@/js/lists.ts";
export default {
  name: "factoringProviderDialog",
  props: {
    factoringProviderId: Number,
    loggedUserData: Object,
    listChange: Function,
    close: Function
  },
  data: function data() {
    return {
      options: {
        color: "primary",
        width: 700,
        zIndex: 2000
      },
      isShown: true,
      isLoadingData: false,
      fetchFactoringProviderToken: null,
      saveCancellationToken: null,
      isValidating: false,
      form: {
        valid: false,
        id: null,
        name: "",
        daysOfDelayAllowed: 0,
        termId: null,
        isProfessional: false,
        isIndividual: false,
        isWholesaler: false,
        isImporter: false,
        terms: null,
        currencies: []
      },
      availableFor: [],
      managedExceptions: {
        warning: {
          NAME_EMPTY: "Name is required",
          TERM_EMPTY: "Term is required",
          CURRENCY_AVAILABLE_EMPTY: "One currency is required",
          CURRENCY_NOT_AVAILABLE: "A currency is not available",
          CUSTOMER_TYPES_AVAILABLE_EMPTY: "One customer type is required"
        }
      },
      formRules: formRules,
      listTerms: listTerms
    };
  },
  computed: {
    isAdding: function isAdding() {
      return +this.form.id <= 0;
    },
    getCurrencies: function getCurrencies() {
      return listCurrencies.filter(function (x) {
        return x.implanted_market;
      });
    },
    getAvailableFor: function getAvailableFor() {
      return [{
        id: "HORECA",
        name: "Professionals"
      }, {
        id: "WHOLESALER",
        name: "Wholesalers"
      }, {
        id: "IMPORTER",
        name: "Importers"
      }, {
        id: "USER",
        name: "Individuals"
      }];
    },
    isInvalid: function isInvalid() {
      return !this.form.valid || this.availableFor.length == 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.form.id = +_this2.factoringProviderId;
            if (_this2.isAdding) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return _this2.fetchFactoringProvider();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchFactoringProvider: function fetchFactoringProvider() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$fetchFactoring;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingData = true;
              (_this3$fetchFactoring = _this3.fetchFactoringProviderToken) === null || _this3$fetchFactoring === void 0 || _this3$fetchFactoring.cancel();
              _this3.fetchFactoringProviderToken = axios.CancelToken.source();
              _this = _this3;
              _context2.next = 6;
              return request("/v1/factoring-provider/".concat(_this3.form.id), "get", null, true, "api", null, _this3.fetchFactoringProviderToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch the factring provider");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  _this.close();
                  throw e;
                }
              });
            case 6:
              response = _context2.sent;
              _this3.form = _objectSpread(_objectSpread({}, _this3.form), response.data.value);
              _this3.availableFor = [];
              if (_this3.form.isProfessional) _this3.availableFor.push("HORECA");
              if (_this3.form.isWholesaler) _this3.availableFor.push("WHOLESALER");
              if (_this3.form.isImporter) _this3.availableFor.push("IMPORTER");
              if (_this3.form.isIndividual) _this3.availableFor.push("USER");
              _this3.isLoadingData = false;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$saveCancellati;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isValidating = true;
              (_this4$saveCancellati = _this4.saveCancellationToken) === null || _this4$saveCancellati === void 0 || _this4$saveCancellati.cancel();
              _this4.saveCancellationToken = axios.CancelToken.source();
              _this4.form.isProfessional = _this4.availableFor.some(function (x) {
                return x == "HORECA";
              });
              _this4.form.isWholesaler = _this4.availableFor.some(function (x) {
                return x == "WHOLESALER";
              });
              _this4.form.isImporter = _this4.availableFor.some(function (x) {
                return x == "IMPORTER";
              });
              _this4.form.isIndividual = _this4.availableFor.some(function (x) {
                return x == "USER";
              });
              data = _objectSpread({}, _this4.form);
              delete data.valid;
              _this = _this4;
              _context3.next = 12;
              return request("/v1/factoring-provider/", "post", data, true, "api", null, _this.saveCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                _this.isValidating = false;
                throw e;
              });
            case 12:
              _this4.isValidating = false;
              _this4.$toasted.show(_this4.isAdding ? "Financing option created" : "Financing option created saved", {
                type: "success"
              });
              _this4.listChange();
              _this4.close();
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this$saveCancellatio;
    (_this$saveCancellatio = this.saveCancellationToken) === null || _this$saveCancellatio === void 0 || _this$saveCancellatio.cancel();
  }
};